const cards = [
  {
    title: '庆余年3 · 权谋风云再起',
    desc: '范闲归来，京都风云变幻。最新剧情高潮迭起，权谋与情感交织，国产古装剧巅峰之作第三季热播中。',
    tag: '国产剧',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20palace%20scene%20with%20warm%20golden%20lighting%2C%20dramatic%20composition%2C%20historical%20costume%20drama%20aesthetic%2C%20soft%20amber%20tones%2C%20elegant%20architecture%20silhouette%2C%20atmospheric%20mood&width=800&height=500&seq=card-show-qingyu&orientation=landscape',
  },
  {
    title: '背着善宰跑 · 心动奇幻之旅',
    desc: '穿越时空的浪漫邂逅，金惠允与边佑锡的化学反应引爆话题，韩剧年度黑马之作。',
    tag: '韩剧',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20warm%20sunset%20lighting%2C%20young%20couple%20running%20together%2C%20dreamy%20atmosphere%2C%20soft%20golden%20hour%20glow%2C%20emotional%20and%20tender%20mood%2C%20cinematic%20composition&width=800&height=500&seq=card-show-seonjae&orientation=landscape',
  },
  {
    title: '繁花 · 上海滩风云录',
    desc: '王家卫执导，胡歌领衔主演。九十年代上海滩的商海沉浮与众生百态，一部视觉与故事俱佳的年代大戏。',
    tag: '国产剧',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20street%20scene%20at%20night%2C%20warm%20neon%20lights%2C%20elegant%20vintage%20atmosphere%2C%20cinematic%20noir%20style%2C%20golden%20and%20amber%20tones%2C%20sophisticated%20mood&width=800&height=500&seq=card-show-fanhua&orientation=landscape',
  },
  {
    title: '泪之女王 · 豪门虐恋',
    desc: '金秀贤与金智媛演绎豪门夫妻的酸甜苦辣，收视率屡创新高，韩剧爱情剧集新标杆。',
    tag: '韩剧',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20interior%20scene%20with%20soft%20candlelight%2C%20romantic%20atmosphere%2C%20Korean%20drama%20aesthetic%2C%20warm%20golden%20and%20cream%20tones%2C%20emotional%20and%20tender%20mood%2C%20sophisticated%20design&width=800&height=500&seq=card-show-queen&orientation=landscape',
  },
  {
    title: '与凤行 · 仙侠新经典',
    desc: '赵丽颖与林更新再度携手，宏大的仙侠世界观搭配细腻情感，国产古装仙侠剧创新力作。',
    tag: '国产剧',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Chinese%20landscape%20with%20floating%20mountains%20and%20warm%20golden%20clouds%2C%20mythical%20atmosphere%2C%20ancient%20Chinese%20aesthetic%2C%20soft%20ethereal%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=card-show-yufeng&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full mb-3">
              编辑精选
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">不容错过的热播好剧推荐</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cards.map((card, i) => (
              <article
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-foreground-800">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}